if (!customElements.get("bundles-slider")) {
  customElements.define(
    "bundles-slider",
    class AccordionItem extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          sliderPrev: "[data-slider-prev]",
          sliderNext: "[data-slider-next]",
          section: ".section",
        };

        this.init();
      }

      init() {
        this.carousel = new Flickity(this, {
          cellAlign: "left",
          wrapAround: true,
          pageDots: false
        });

        this.section = this.closest(this.selectors.section);
        this.section.querySelectorAll(this.selectors.sliderPrev).forEach((button) => {
          button.addEventListener("click", () => {
            this.carousel.previous();
          });
        });

        this.section.querySelectorAll(this.selectors.sliderNext).forEach((button) => {
          button.addEventListener("click", () => {
            this.carousel.next();
          });
        });
      }
    }
  );
}
